module.exports = __webpack_public_path__ + "img/pro_five_3.00bad753.jpg";